/* eslint-disable max-lines */
import React from 'react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import classNames from 'classnames';
import { fromJS } from 'immutable';
import { ContextMenuTrigger } from '@naumandev/react-context-menu';
import { withStyles } from 'tss-react/mui';
import TableBody from '@mui/material/TableBody';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import blue from '@mui/material/colors/blue';
import teal from '@mui/material/colors/teal';
import red from '@mui/material/colors/red';
import orange from '@mui/material/colors/orange';
import yellow from '@mui/material/colors/yellow';
import green from '@mui/material/colors/green';
import grey from '@mui/material/colors/grey';
import Box from '@mui/material/Box';
import { NOT_QUA } from '@lba-dev/package.local-globals/aLevel';
import { AS_QUA } from '@lba-dev/package.local-globals/aSubStatus';
import {
  I_APR,
  I_ANN,
  I_ENC,
  I_AVR,
  I_VRF,
} from '@lba-dev/package.local-globals/iStatus';
import { R_POR } from '@lba-dev/package.local-globals/remStatus';
import { groupBy } from '@lba-dev/package.local-globals/functions';
import {
  data as postmarkStatus
} from '@lba-dev/package.local-globals/postmarkStatus';
import {
  infoArtisans,
  infoClients,
} from '@lba-dev/package.local-globals/checkListInfoInter';
import {
  DF_CEE_PAYE,
  DF_MPR_PAYE,
} from '@lba-dev/package.local-globals/caldeoType';
import {
  Person,
  LocalPostOffice,
  RemoveRedEye,
  Star,
  NotificationImportantRounded,
} from '@mui/icons-material';
import Badge from '@mui/material/Badge';
import {
  globalStatus,
  A_CONTACTER,
  G_INT,
} from '@lba-dev/package.local-globals/statusProsp';
import { D_REF } from '@lba-dev/package.local-globals/demandeStatus';
import { globalStatusProsp } from '@lba-dev/package.local-globals/getDataById';

import styles from './Components/styles';
import CountDown from '../CountDown';
import ChronoLitiges from '../ChronoLitiges';
import Money from '../../utils/Money';
import { BankInfo } from '../BankInfo';
import { genChip } from '../../utils/chips';
import {
  IconsDisplay,
  forfaitIcon,
  CallIcon,
  cbPayment,
  devisIcon,
  subStatusDevisIcon,
  validInfosIcon,
  editIcon,
  mailOutlineIcon,
  mailOutlinePaddingIcon,
  demandesIcons,
  SupportPoints,
  SupplieProgressIcon,
  metiersStepsCounter,
  grandCompteIcon,
  UpdateProposition,
  meetingIcon
} from '../../utils/IconsDisplay';
import { Types } from '../../utils/List/Types';
import { formatTooltipArtisan } from '../../actions/artisan';
import {
  firstCallDiff,
  getGrandCompteMarge,
  getGrandCompteMargePercent,
  getLogin,
  getMetierName,
  getPaymentModes,
  isUsingFallbackDesc,
  truncateForDisplay,
} from '../../utils/function';
import { changeStatusColor } from '../Utils/changeStatusColor';
import collections from '../../constants/collections';
import { getTeam } from '../../utils/teams';
import ProgressLine from '../Utils/ProgressLine';
import { withMediaQuery } from '../../hoc';
import { formatDuration, getDateOrTime } from '../../utils/date';
import CustomCheckbox from '../CustomInputs/CustomCheckbox';
import TableCollapse from '../TableCollapse';
import CustomImg from '../Utils/CustomImg';


const avatarStyles = {
  undefined: { backgroundColor: '#000000' },
  1: { backgroundColor: green['500'] },
  2: { backgroundColor: orange['500'] },
};

const civility = {
  Madame: 'Mme.',
  Monsieur: 'M.',
  Société: 'Soc.',
};

function genStatus(elem, short) {
  return (
    elem && (
      <span
        key={elem.name}
        style={{
          color: elem.color['500'],
          display: 'inline-flex',
        }}
      >
        {short ? elem.shortName : elem.name}
      </span>
    )
  );
}

function genButton(elem, short) {
  return (
    elem && (
      <Button
        key={elem.name}
        style={{
          backgroundColor: elem.color[elem.name === 'neutre' ? '600' : '500'],
          maxWidth: short ? '30%' : '',
          color: 'white',
          fontSize: '11px',
          margin: '0.6%',
          width: short ? '' : '100%',
          minWidth: 40,
        }}
      >
        {short ? elem.shortName : elem.name}
      </Button>
    )
  );
}

const formatField = {
  login: ({ obj = '', users }) =>
    (getLogin(obj.toLowerCase(), undefined, users) || '').toUpperCase(),
  date: ({ obj, width }) => getDateOrTime(obj, width),
};

function getter(obj, arg, width = '', users) {
  let formatType = '';
  arg = arg.split('.');
  arg.forEach((e) => {
    if (obj) {
      if (e === 'date') {
        formatType = 'date';
      }
      if (e === 'login') {
        formatType = 'login';
      }
      obj = obj[e];
    }
  });
  if (typeof obj === 'string') {
    obj =
      arg.includes('civility') && civility[obj]
        ? civility[obj]
        : obj.toUpperCase();
  }
  return formatType ? formatField[formatType]({ obj, width, users }) : obj;
}

function gettermail(obj) {
  const data = postmarkStatus.find((e) => e._id === obj.postmarkmail);
  return data ? (
    <LocalPostOffice
      style={{
        color: data.color ? data.color[500] : null,
        width: '0.8em',
      }}
    />
  ) : (
    ''
  );
}

function genSourceLogo(props, elem, i) {
  if (props.tableData[i].logoArtisan && props.tableData[i].sourceArtisan) {
    const source = getter(elem, props.tableData[i].sourceArtisan);
    const sourceLogo = props.tableData[i].logoArtisan[source];
    return (
      sourceLogo && (
        <span
          key={'spanLogo'}
          style={{ fontSize: 10, display: 'inline-block', width: '100%' }}
        >
          <Tooltip disableInteractive title={source} placement="top">
            <CustomImg
              src={sourceLogo}
              alt="logo source artisan"
              style={{ width: '30px', height: 'auto' }}
            />
          </Tooltip>
        </span>
      )
    );
  }
  return null;
}

function genElemStatus(props, elem, i, subkeys) {
  const text =
    Array.isArray(subkeys) && subkeys.some((k) => k.includes('currentArtisan'))
      ? subkeys.map((k) => getter(elem, k)).join(' ')
      : getter(elem, subkeys[0]);
  const name = text ? `${text.charAt(0)}_${text.slice(-1)}` : '';
  if (props.tableData[i].status) {
    const chip = genStatus(
      (props.elem &&
        props.elem.status !== I_APR &&
        props.elem.sendArtisan &&
        props.elem.sendArtisan.subStatusArtisanInterv &&
        props.tableData[i].status.find(
          (e) => e._id === props.elem.sendArtisan.subStatusArtisanInterv
        )) ||
      props.tableData[i].status.find(
        (e) => e._id === getter(elem, props.tableData[i].key)
      ),
      (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') || props.small
    );
    return [
      props.elem.artisan && forfaitIcon(props),
      `${text || ''} `,
      <span key={'span'} style={{ fontSize: 10 }}>
        {chip}
      </span>,
      genSourceLogo(props, elem, i),
    ];
  }
  return (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') || props.small
    ? name
    : getter(elem, subkeys) || '';
}

function genIcon(props, _elem, i, key) {
  if (key === 'date.meeting' && props.elem.date) {
    return meetingIcon({
      meeting: props.elem.date.meeting,
      createMeeting: props.elem.date.createMeeting,
      declinedMeeting: props.elem.date.declinedMeeting
    });
  } else if (key === 'appel') {
    return <CallIcon {...props} />;
  } else if (key === 'supplieProgress') {
    return (
      <SupplieProgressIcon
        list={(props.tableData[i] || {}).list}
        elem={props.elem}
        classes={props.classes}
      />
    );
  } else if (
    props.elem.date &&
    props.elem.date.recouvrementEnd &&
    !props.elem.date.recouvrement
  ) {
    return (
      <CountDown
        timer={props.elem.date.recouvrementEnd}
        recouvrementTimer={true}
      />
    );
  } else if (
    props.elem.date &&
    props.elem.date.ajoutRecouvrement &&
    !props.elem.date.recouvrement
  ) {
    return <ChronoLitiges timer={props.elem.date.ajoutRecouvrement} />;
  } else if (key === 'isPriority' && _elem) {
    const hasMeeting = (
      props.elem.date &&
      props.elem.date.meeting &&
      !props.elem.date.declinedMeeting
    );
    return hasMeeting && (
      <NotificationImportantRounded
        style={{
          color: 'red',
        }}
      />
    );
  }
  return null;
}

function genDate(key, props, i, classes) {
  const hoursRemaining = dayjs(props.elem.date.intervention).diff(
    dayjs(),
    'hours'
  );
  const minutesRemaining = dayjs(props.elem.date.intervention).diff(
    dayjs(),
    'minutes'
  );
  if (
    props.tableData[i].blink &&
    hoursRemaining >= 0 &&
    hoursRemaining <= 2 &&
    minutesRemaining <= 120
  ) {
    return (
      <div
        className={classes.blink}
        style={{
          backgroundColor: props.tableData[i].color,
        }}
      >
        {getter(props.elem, key, props.breakpoint)}
      </div>
    );
  } else if (
    key.includes('firstCall') &&
    props.elem.date.ajout &&
    props.elem.date.firstCall
  ) {
    return firstCallDiff(props.elem.date.firstCall, props.elem.date.ajout);
  } else if (
    key.includes('intervention') &&
    !props.elem.definDClient &&
    !props.elem.definHClient
  ) {
    return getter(props.elem, key, props.breakpoint);
  }
  return getter(props.elem, key, props.breakpoint);
}

function colorRow({
  encaissement = 0,
  decaissement = 0,
  finalPrice = 0,
  announcedPrice = 0,
  products: { tva = 10 } = { tva: 10 },
  date,
  isRegle,
  login,
  locked,
  isMarketList,
}) {
  if (
    encaissement &&
    encaissement - decaissement &&
    encaissement - decaissement <
    (finalPrice || announcedPrice) * ((tva / 100) + 1) &&
    date &&
    !isRegle
  ) {
    return teal[50];
  }
  if (isRegle) {
    return green[200];
  }
  if (locked) {
    return grey[500];
  }
  if (login && login.market && !isMarketList) {
    return grey[300];
  }

  return '';
}

function getTypes(classes) {
  const typeComponents = {
    [Types.Text]: (key, props, i) =>
      (typeof key === 'string' && key !== 'postmarkmail' && (
        <TableCell
          padding="checkbox"
          style={{ overflow: 'hidden' }}
          className={classNames(
            classes[props.tableData[i].class],
            classes[key === 'id' ? 'width-100' : ''],
            classes.overflowing
          )}
          key={key}
        >
          <div className={classes.avatarContainer}>
            <span>
              {getter(props.elem, key, props.breakpoint, props.users)}
            </span>
            {key === 'id' &&
              Object.keys(IconsDisplay).map((e) => IconsDisplay[e](props))}
            {key === 'companyName' && genSourceLogo(props, props.elem, i)}
          </div>
        </TableCell>
      )) ||
      (typeof key === 'string' && key === 'postmarkmail' && (
        <TableCell padding="checkbox" key={key}>
          {gettermail(props.elem)}
        </TableCell>
      )) || (
        <TableCell
          padding="checkbox"
          className={classNames(
            classes[props.tableData[i].class],
            classes.overflowing
          )}
          key={key}
        >
          <Typography
            className={classes.grandCompteTooltip}
            component="span"
          >
            {key.includes('client.society') &&
              getter(props.elem, key[0]) === 'Soc.'
              ? `${getter(props.elem, key[0])} ${getter(props.elem, key[3]) ||
              key
                .slice(1, 3)
                .map((sub) => `${getter(props.elem, sub) || ''} `)
                .join(' ')
              }`
              : key.map((sub) => `${getter(props.elem, sub) || ''} `)}
            {key.includes('client.name') &&
              !props.elem.onSitePayment &&
              props.elem.billing &&
              props.elem.billing.grandCompte &&
              grandCompteIcon(props)}
          </Typography>
        </TableCell>
      ),
    [Types.Chip]: (key, props, i) => {
      let elem = getter(props.elem, key);
      if (key === 'subStatus' && props.elem.level !== NOT_QUA) {
        elem = AS_QUA;
      }
      let chips = null;
      if (elem && elem instanceof Array) {
        chips = (
          <div>
            {elem.map((o) =>
              genChip(
                props.tableData[i].list.find((e) => e._id === o),
                (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') ||
                props.small,
                elem.length
              )
            )}
          </div>
        );
      } else {
        let statusElem =
          props.tableData[i].list.find((e) => e._id === elem) || {};
        if (
          key === 'status' &&
          [collections.interventions, collections.recouvrements].includes(
            props.listen
          )
        ) {
          statusElem = changeStatusColor(props.elem, props.listen)[elem];
        }
        chips = genChip(
          statusElem,
          (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') ||
          props.small,
          1,
          props.elem && props.elem.emptyCancel && props.elem.status === I_ANN
        );
      }
      if (collections.interventions === props.listen && key === 'status') {
        return <TableCell padding="checkbox" key={key}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
          }}>
            {chips}
            <UpdateProposition elem={props.elem} />
          </div>

        </TableCell>

      }
      return (
        <TableCell padding="checkbox" key={key}>
          {chips}
        </TableCell>
      );
    },
    [Types.RefId]: (key, props, i) => (
      <TableCell
        padding="checkbox"
        style={{
          color:
            props.elem.aDemarcher && props.elem.status === I_APR && red[500],
        }}
        className={classes[props.tableData[i].class]}
        key={key}
      >
        {(props.elem.aDemarcher &&
          props.elem.status === I_APR &&
          `A démarcher ${props.elem.prospSms ? `${props.elem.prospSms} sms reçus` : ''
          }`) ||
          genElemStatus(props, props.elem, i, key) ||
          ''}
      </TableCell>
    ),
    [Types.Money]: (key, props, i) => {
      let color = 'inherit';
      let backgroundColor = 'transparent';

      // Effet visuel pour caldeoSubStatus 6e et 6f
      const caldeoSubStatus = props.elem?.caldeo?.subStatus;
      if (caldeoSubStatus === DF_CEE_PAYE && key === 'ceeAmount') {
        backgroundColor = green[100];
      } else if (caldeoSubStatus === DF_MPR_PAYE && key === 'anahAmount') {
        backgroundColor = green[100];
      }

      if (key === 'finalPrice') {
        const products = getter(props.elem, 'products.list') || [];
        const comboIndex = ((props.elem || {}).products || {}).comboIndex;
        const productsGroup = groupBy(products, 'comboIndex');
        return (
          <TableCell key={key} style={{ padding: '4px 10px' }}>
            <div className={classes.priceDiv}>
              <div className={classes.price}>
                {!isNaN(comboIndex) && Object.keys(productsGroup).length > 1
                  ? ''
                  : `${Money.toString(
                    products.reduce((e, v) => e + (v.qt * v.pu), 0) || 0
                  )} \u20AC`}
              </div>
              {mailOutlinePaddingIcon(props, i)}
            </div>
          </TableCell>
        );
      }

      let money = Money.toString(getter(props.elem, key) || 0);
      if (
        !!getter(props.elem, key) &&
        !!props.elem.savedAnnouncedPrice &&
        props.elem.status === I_VRF &&
        props.elem.finalPrice !== props.elem.savedAnnouncedPrice
      ) {
        color = props.elem.finalPrice > props.elem.savedAnnouncedPrice
          ? green[500]
          : red[500];
      }
      if (key === 'announcedPrice') {
        money = Money.toString(
          getter(
            props.elem,
            props.elem.status !== I_VRF ? 'announcedPrice' : 'finalPrice'
          ) || 0
        );
      } else if (key.includes('savedFinalPrice')) {
        money = Money.toString(
          getter(props.elem, key) || getter(props.elem, 'finalPrice')
        );
      }
      return (
        <TableCell
          key={key}
          style={{ minWidth: '200px', padding: '0px 0px', backgroundColor }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={4}>
              <div style={{ textAlign: 'center', color }} >
                {money} {'\u20AC'}
              </div>
            </Grid>
            {
              key === 'announcedPrice' && (
                <Grid container item xs={8} spacing={2}>
                  <Grid item xs={2}>
                    {cbPayment(props)}
                  </Grid>
                  <Grid item xs={2}>
                    {mailOutlineIcon(props, i)}
                  </Grid>
                  <Grid item xs={2}>
                    {devisIcon(props)}
                  </Grid>
                  <Grid item xs={1}>
                    {subStatusDevisIcon(props)}
                  </Grid>
                  <Grid item xs={1}>
                    {validInfosIcon(props, infoArtisans, infoClients)}
                  </Grid>
                  <Grid item xs={2}>
                    {editIcon(props)}
                  </Grid>
                </Grid>
              )
            }
          </Grid>
        </TableCell>
      );

    },
    [Types.artisanRef]: (key, props, i) => {
      if (
        props.elem.date &&
        props.elem.date.demarchage !== undefined &&
        props.elem.artisan === undefined
      ) {
        const user = props.users.find(
          (e) => props.elem.login && e._id === props.elem.login.demarchage
        );
        return (
          <TableCell
            padding="checkbox"
            style={{ fontWeight: 'bold' }}
            key={key}
          >
            <CountDown
              timer={props.elem.date.demarchageEnd}
              demarchagePause={props.elem.date.demarchagePause}
            >
              <span
                style={{
                  color: blue['500'],
                  display: 'inline',
                  marginLeft: '3px',
                }}
              >
                ({user && user.login})
              </span>
            </CountDown>
          </TableCell>
        );
      }
      return getTypes(props.classes)[Types.RefId](key, props, i);
    },
    [Types.History]: (key, props, i) => {
      const avatarStyle = avatarStyles[getter(props.elem, key)] || {
        backgroundColor: red['500'],
      };
      return (
        typeof key === 'string' && (
          <TableCell
            padding="checkbox"
            className={classNames(
              classes[props.tableData[i].class],
              classes.avatarContainer
            )}
            key={key}
          >
            <Avatar style={avatarStyle}>
              {getter(props.elem, key) === undefined
                ? '0'
                : getter(props.elem, key)}
            </Avatar>
          </TableCell>
        )
      );
    },
    [Types.Icon]: (key, props, i) => {
      const elem = getter(props.elem, key);
      return (
        <TableCell
          padding="checkbox"
          className={classes[props.tableData[i].class]}
          key={key}
        >
          {genIcon(props, elem, i, key)}
        </TableCell>
      );
    },
    [Types.Rectangle]: (key, props, i) => {
      const elem = getter(props.elem, key);
      return (
        props.tableData[i].list && (
          <TableCell
            padding="checkbox"
            style={{ textAlign: 'center' }}
            className={classes[props.tableData[i].class]}
            key={key}
          >
            {(elem && elem instanceof Array && (
              <div>
                {elem.map((o) =>
                  genButton(
                    props.tableData[i].list.find((e) => e._id === o),
                    true
                  )
                )}
              </div>
            )) ||
              genButton(
                props.listen &&
                  collections.demandes &&
                  elem === D_REF &&
                  props.elem.raisonRefus &&
                  props.elem.raisonRefus.length < 25
                  ? {
                    ...props.tableData[i].list.find((e) => e._id === elem),
                    name: props.elem.raisonRefus,
                  }
                  : props.tableData[i].list.find((e) => e._id === elem),
                (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') ||
                props.small
              )}
          </TableCell>
        )
      );
    },
    [Types.Stars]: (key, props, i) => {
      const nStars = Number(getter(props.elem, key)) || 0;
      const color =
        (nStars < 3 && red[500]) || (nStars < 4 && orange[500]) || yellow[500];
      return (
        <TableCell
          padding="checkbox"
          style={{ textAlign: 'center' }}
          className={classes[props.tableData[i].class]}
          key={key}
        >
          {[...Array(nStars).keys()].map(
            (e, i) => i < 5 &&
            <Star
              key={e}
              style={{ color, fontSize: 15 }} />
          )}
        </TableCell>
      );
    },
    [Types.Date]: (key, props, i) => (
      <TableCell
        padding="checkbox"
        style={{ textAlign: 'center' }}
        className={classes[props.tableData[i].class]}
        key={key}
      >
        {key.includes('intervention') &&
          props.elem.definDClient &&
          props.elem.definHClient &&
          'RDV à définir'}
        {key.includes('intervention') &&
          !props.elem.definDClient &&
          props.elem.definHClient &&
          `${dayjs(props.elem.date.intervention).format('L')}
             heure à définir`}
        {key.includes('intervention') &&
          props.elem.definDClient &&
          !props.elem.definHClient &&
          `date à définir
             ${dayjs(props.elem.date.intervention).format('HH[h]mm')}`}
        {genDate(key, props, i, classes)}
      </TableCell>
    ),
    [Types.Pourcentage]: (key, props, i) => {
      let elem = '';
      if (
        key !== 'remuneration.pourcentage.labor' ||
        props.elem.remuneration.status === R_POR
      ) {
        elem = getter(props.elem, key, props.breakpoint);
      }

      return (
        <TableCell
          key={key}
          padding="checkbox"
          style={{ textAlign: 'center' }}
          className={classes[props.tableData[i].class]}
        >
          <Typography
            className={classes.bold}
            style={{
              color:
                (elem.status === R_POR &&
                  ((elem.pourcentage.labor >= 50 && red[500]) ||
                    (elem.pourcentage.labor >= 40 && orange.A200))) ||
                null,
            }}
            children={
              elem.status === R_POR ? `${elem.pourcentage.labor}%` : 'FOR'
            }
          />
        </TableCell>
      );
    },
    [Types.Rib]: (key, props) => (
      <TableCell key={key} style={{ textAlign: 'center' }}>
        <Button
          aria-label="Add"
          onClick={(e) => {
            e.stopPropagation();
            props.setDialog(BankInfo, true, fromJS(props.elem), () =>
              props.setDialog(null, false, null, null)
            );
          }}
        >
          <RemoveRedEye />
        </Button>
      </TableCell>
    ),
    [Types.DemandeClient]: (key, props, i) => (
      <TableCell
        padding="checkbox"
        style={{ overflow: 'hidden' }}
        className={classNames(
          classes[props.tableData[i].class],
          classes.overflowing
        )}
        key={key}
      >
        <div className={classes.avatarContainer}>
          <div className={classes.extendedIcon}>{demandesIcons(props)}</div>
          <span>
            {!key
              .slice(1, -1)
              .map((s) => getter(props.elem, s))
              .every((e) => e)
              ? getter(props.elem, key[key.length - 1]) || ''
              : key
                .slice(
                  key.includes('client.name') && !!getter(props.elem, key[1])
                    ? 1
                    : 0,
                  -1
                )
                .map((sub) => `${getter(props.elem, sub) || ''} `)
                .join(' ')}
          </span>
        </div>
      </TableCell>
    ),
    [Types.DemandeZipCode]: (key, props, i) => (
      <TableCell
        padding="checkbox"
        style={{ overflow: 'hidden' }}
        className={classNames(
          classes[props.tableData[i].class],
          classes.overflowing
        )}
        key={key}
      >
        <div className={classes.avatarContainer}>
          {props.elem.artisans && props.elem.artisans.length ? (
            <div className={classes.extendedIcon}>
              <Badge badgeContent={props.elem.artisans.length}>
                <Tooltip
                  disableInteractive
                  title={formatTooltipArtisan(props.elem.artisans)}
                >
                  <Person />
                </Tooltip>
              </Badge>
            </div>
          ) : null}
          <b>{getter(props.elem, key, props.breakpoint)}</b>
        </div>
      </TableCell>
    ),
    [Types.nomGramdCompte]: (key, props, i) => {
      const element = getter(props.elem, key, props.breakpoint);
      return (
        <TableCell
          padding="checkbox"
          style={{ overflow: 'hidden' }}
          className={classNames(
            classes[props.tableData[i].class],
            classes.overflowing
          )}
          key={key}
        >
          <div className={classes.avatarContainer}>
            <b>{element}</b>
          </div>
        </TableCell>
      );
    },
    [Types.margeBtobPrice]: (key, props) => (
      <TableCell
        padding="checkbox"
        style={{ overflow: 'hidden' }}
        className={classes.overflowing}
        key={key}
      >
        <div className={classes.avatarContainer}>
          <b>{getGrandCompteMarge(props.elem)} €</b>
        </div>
      </TableCell>
    ),
    [Types.margeBtobPercent]: (key, props) => (
      <TableCell
        padding="checkbox"
        style={{ overflow: 'hidden' }}
        className={classes.overflowing}
        key={key}
      >
        <div className={classes.avatarContainer}>
          <b>{getGrandCompteMargePercent(props.elem)} %</b>
        </div>
      </TableCell>
    ),
    [Types.Sstatus]: (key, props) => {
      const elem = getter(props.elem, key);
      const rac = elem ? elem.split('/').splice(2)[0] : '';
      return (
        <TableCell padding="checkbox" key={key}>
          {rac &&
            genChip(
              { name: rac, color: grey },
              (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') ||
              props.small,
              rac
            )}
        </TableCell>
      );
    },
    [Types.Points]: (key, props) => {
      const dateIntervention = dayjs(
        props.elem?.date?.intervention || new Date()
      );
      const diffrentDate = dayjs().diff(dateIntervention, 'days') + 1;
      return (
        <TableCell align="center" padding="checkbox" key={key}>
          <Box fontWeight="fontWeightBold">
            {[I_ENC, I_AVR].includes(props.elem?.status) && diffrentDate >= 0
              ? diffrentDate - (props.elem?.nbPointsAverifNotWorking || 0)
              : 0}
          </Box>
        </TableCell>
      );
    },
    [Types.SupportPoints]: (key, { elem }) => (
      <TableCell
        align="center"
        padding="checkbox"
        key={key}
        style={{ width: '10%' }}
      >
        <SupportPoints elem={elem} />
      </TableCell>
    ),
    [Types.DemandeCat]: (key, props, i) => (
      <TableCell
        padding="checkbox"
        style={{ overflow: 'hidden', textAlign: 'center' }}
        className={classNames(
          classes[props.tableData[i].class],
          classes.overflowing
        )}
        key={key}
      >
        <div>
          {genButton(
            props.tableData[i].list.find(
              (e) => e._id === getter(props.elem, 'categorie')
            ),
            true
          )}
        </div>
      </TableCell>
    ),
    [Types.Equipe]: (key, props) => (
      <TableCell padding="checkbox">
        {getTeam(
          props.elem,
          props.users.toJS(),
          props.listen
        ).login.toUpperCase()}
      </TableCell>
    ),
    [Types.EtatProspection]: (key, props) => {
      const openAction = (e) => {
        window.open(`/prosp/list?interSearch=${props.elem.id}`);
        e.stopPropagation();
      };
      return (
        <TableCell padding="checkbox">
          {props.elem?.date?.demarchageDuration ? (
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} onClick={openAction}>
                <ProgressLine
                  visualParts={props.elem?.prosp?.statusCounters
                    .reduce((acc, curr) => {
                      const status = globalStatus.find((s) =>
                        s.childs.includes(curr.status)
                      );
                      const findElement = acc.findIndex(
                        (s) => s._id === status._id
                      );
                      if (~findElement) {
                        acc[findElement].count += curr.count;
                        acc[findElement].percentage += Math.trunc(
                          (100 * curr.count) / props.elem.prosp.total
                        );
                        acc[
                          findElement
                          // eslint-disable-next-line prefer-template
                        ].title = '- ' + status.name + ' (' +
                        acc[findElement].count + ')';
                      } else {
                        acc.push({
                          // eslint-disable-next-line prefer-template
                          title: '- ' + status.name + ' (' + curr.count + ')',
                          percentage: Math.trunc(
                            (100 * curr.count) / props.elem.prosp.total
                          ),
                          color: status.color,
                          count: curr.count,
                          _id: status._id,
                        });
                      }
                      return acc;
                    }, [])
                    .sort((e, v) => v._id - e._id)}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography>
                  {
                    `${props.elem?.prosp?.total
                      ? Math.trunc(
                        100 -
                        ((100 *
                          (props.elem?.prosp?.statusCounters.find(
                            (s) => s.status === A_CONTACTER
                          )?.count || 0)) /
                          props.elem.prosp.total)
                      )
                      : 0
                    }%`
                  }
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Button
              onClick={openAction}
              fullWidth
              variant="contained"
              color="primary"
            >{`GO (${props.elem?.prosp?.total || 0})`}</Button>
          )}
        </TableCell>
      );
    },
    [Types.ProspeFound]: (key, props) => {
      const status = (props.elem?.prosp?.statusCounters || []).reduce(
        (acc, curr) => {
          if (globalStatusProsp[G_INT].childs.includes(curr.status)) {
            acc.count += curr.count;
            acc.dispoStatus += curr.dispoStatus;
          }
          return acc;
        },
        { count: 0, dispoStatus: 0 }
      );
      return (
        <TableCell padding="checkbox">
          <Button
            style={{
              backgroundColor: status.count ? green[500] : red[500],
              textAlign: 'center',
              color: '#fff',
              margin: 'auto',
              display: 'flex',
              width: '50%',
            }}
            variant="contained"
            href={`/prosp/list/dispo?interSearch=${props.elem.id}`}
          >
            {status.dispoStatus || 0} / {status.count || 0}
          </Button>
        </TableCell>
      );
    },
    [Types.Debrief]: (key, props) => {
      const nb = Object.values(props.elem[key] || {}).reduce(
        (acc, curr) => (curr.checked ? acc + 1 : acc),
        0
      );
      return (
        <TableCell padding="checkbox" key={key}>
          {`${nb}/${Object.keys(props.elem[key] || {}).length || 10}`}
        </TableCell>
      );
    },
    [Types.StepMetierName]: (key, props) => {
      const name = getMetierName(props.elem);
      const isFallback = isUsingFallbackDesc(props.elem);
      const displayName = isFallback
        ? truncateForDisplay(name, 4)
        : name;
      const element = {
        name,
        collection: props.elem.metiersSteps
          ? collections.metiersSteps : collections.metiersDevis
      };
      return (
        <TableCell padding="checkbox" key={key} sx={{ minWidth: 150 }} >
          <Tooltip disableInteractive title={element.name || ''}>
            {element.name ? (
              <Typography
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {displayName}
                {metiersStepsCounter(props, element.collection)}
              </Typography>
            ) : (
              <Typography />
            )}
          </Tooltip>
        </TableCell>
      );
    },
    [Types.ServiceName]: (key, props) => {
      const service = getter(props.elem, key);
      return (
        <TableCell padding="checkbox" key={key}>
          <span>
            {(props.elem?.billing?.grandCompte &&
              props.elem?.billing?.companyName?.toUpperCase()) ||
              '' ||
              props.elem?.demande?.source?.toUpperCase() ||
              service}
          </span>
        </TableCell>
      );
    },
    [Types.DelaisEncaissement]: (key, props) =>
      <TableCell padding="checkbox" key={key}>
        <span>
          {props.elem.date.reglement && formatDuration(
            dayjs(new Date(props.elem.date.reglement))
              .diff(new Date(props.elem.date.verif)),
            ['days']
          )}
        </span>
      </TableCell>,
    [Types.SelectForCampaign]: (key, props) => (
      <TableCell key={key}
        onClick={(e) => {
          e.stopPropagation();
        }}
        padding="checkbox"
        style={{ textAlign: 'center', width: '1%' }}
      >
        <CustomCheckbox
          checked={props.elem.selectForCampaign}
          setData={() => {
            props.setSelectedForCampaign(props.elem)
          }
          }
          CheckboxOnly={true}
        />
      </TableCell>
    ),
    [Types.RStatus]: (key, props, i) => {
      const elem = getter(props.elem, key);
      const statusElem = props.tableData[i].list
        .find((e) => e._id === elem) || {};
      const chips = genChip(
        {
          name: statusElem.mauvaisAlias || statusElem.name,
          color: statusElem.color,
        },
        (props.breakpoint !== 'lg' && props.breakpoint !== 'xl') ||
          props.small,
        1,
        props.elem && props.elem.emptyCancel && props.elem.status === I_ANN
      );
      return (
        <TableCell padding="checkbox" key={key}>
          {chips}
        </TableCell>
      )
    },
    [Types.RemainingCharge]: (key, props) => {
      const price = props.elem?.announcedPrice || 0;
      const ceeAmount = props.elem?.ceeAmount || 0;
      const anahAmount = props.elem?.anahAmount || 0;
      const remainingCharge = Math.max(0, price - (ceeAmount + anahAmount));

      return (
        <TableCell key={key} style={{ textAlign: 'center' }}>
          <Typography>
            {Money.toString(remainingCharge)} {'\u20AC'}
          </Typography>
        </TableCell>
      );
    },
    [Types.CBPayment]: (key, props) => {
      const paymentModes = getPaymentModes(props.elem);
      return (
        <TableCell padding="checkbox" key={key} style={{ textAlign: 'center' }}>
          <Typography>
            {paymentModes}
          </Typography>
        </TableCell>
      );
    },
  };
  return typeComponents;
}

const ListRow = (props) => {
  const {
    user,
    elem,
    keys,
    histories,
    appels,
    table,
    tableData,
    users,
    open,
    idMenu,
    colSpan,
    menu: Menu,
    setSelected,
    openDrop,
    classes,
    listen,
    name,
  } = props;

  return (
    <React.Fragment>
      <ContextMenuTrigger
        id={idMenu || 'SIMPLE'}
        holdToDisplay={850}
        collect={() => {
          setSelected(elem);
          return { elem };
        }}
        attributes={{
          style: { cursor: 'pointer' },
          onClick: () => openDrop(props),
        }}
        renderTag={TableBody}
      >
        <TableRow
          hover
          style={{ backgroundColor: colorRow(elem) }}
          children={keys.map((k, i) =>
            getTypes(classes)[table[i]](k, props, i)
          )}
        />
      </ContextMenuTrigger>
      {Menu && (
        <TableCollapse
          colSpan={colSpan}
          in={open === elem.id}
          transitionDuration="auto"
          unmountOnExit
        >
          <Menu
            histories={histories}
            appels={appels}
            elem={elem}
            users={users}
            user={user}
            listen={listen}
            name={name}
            artisan={
              tableData[6] &&
              tableData[6].list &&
              tableData[6].list.find((e) => e._id === elem.artisan)
            }
          />
        </TableCollapse>
      )}
    </React.Fragment>
  );
};

export default withMediaQuery()(withStyles(ListRow, styles));
